import { createReducer, on } from '@ngrx/store';
import { RolesActions } from './roles.actions';
import { RoleSliceState } from '../../models/role';


export const initialState: RoleSliceState = {
  items: [],
  status: {
    fetchPaginate: 'idle',
    fetchAll: 'idle',
    create: 'idle',
    update: 'idle',
    delete: 'idle',
    toggleStatus: 'idle',
  },
  error: {
    fetchPaginate: { message: null },
    fetchAll: { message: null },
    create: { message: null },
    update: { message: null },
    delete: { message: null },
    toggleStatus: { message: null },
  },
  pagination: {
    limit: 10,
    previousPage: null,
    currentPage: 1,
    nextPage: null,
    totalItems: 0,
    totalPage: 0,
  },
};

export const RolesReducer = createReducer(
  initialState,

  // === FETCH ALL ===
  on(RolesActions.fetchAll, (state) => ({
    ...state,
    status: { ...state.status, fetchAll: 'pending' },
  })),
  on(RolesActions.fetchAllSuccess, (state, { items }) => ({
    ...state,
    items,
    status: { ...state.status, fetchAll: 'succeeded' },
  })),
  on(RolesActions.fetchAllFailure, (state, { error }) => ({
    ...state,
    status: { ...state.status, fetchAll: 'failed' },
    error: { ...state.error, fetchAll: error },
  })),

  // === FETCH PAGINATED ===
  on(RolesActions.fetchPaginated, (state) => ({
    ...state,
    status: { ...state.status, fetchPaginate: 'pending' },
  })),
  on(RolesActions.fetchPaginatedSuccess, (state, { items, pagination }) => ({
    ...state,
    items,
    pagination,
    status: { ...state.status, fetchPaginate: 'succeeded' },
  })),
  on(RolesActions.fetchPaginatedFailure, (state, { error }) => ({
    ...state,
    status: { ...state.status, fetchPaginate: 'failed' },
    error: { ...state.error, fetchPaginate: error },
  })),

  // === TOGGLE STATUS ===
  on(RolesActions.toggleStatus, (state) => ({
    ...state,
    status: { ...state.status, toggleStatus: 'pending' },
  })),
  on(RolesActions.toggleStatusSuccess, (state, { Role }) => ({
    ...state,
    items: state.items.map((p) => (p.id === Role.id ? Role : p)),
    status: { ...state.status, toggleStatus: 'succeeded' },
  })),
  on(RolesActions.toggleStatusFailure, (state, { error }) => ({
    ...state,
    status: { ...state.status, toggleStatus: 'failed' },
    error: { ...state.error, toggleStatus: error },
  }))
);
